import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from "@angular/common/http";
import { Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class ConfigService {
  private authUrl = `${environment.authUrl}/frontoffice`;
  constructor(private http: HttpClient) {}
  public getConfigs(): Observable<HttpResponse<any>> {
    return this.http.get(`${this.authUrl}/config`, {
      params: {},
      observe: "response",
    });
  }

  public getSettings(): Observable<HttpResponse<any>> {
    return this.http.get(`${this.authUrl}/settings`, {
      params: {},
      observe: "response",
    });
  }
}
